export default __webpack_public_path__ + "static/media/img12_s.5f92b641.png";